import {
  getLeoUuid,
  LeoUUID,
  getString,
  getLeoTimestamp,
  LeoTimestamp,
  getOptionalLeoUuid,
} from "@surya-digital/leo-ts-types";

export interface GetActiveResearcherProjectsPaginationResponseDTO {
  projectId: string;
  projectName: string;
  creator: string;
  surveys: string;
  createdOn: string;
  lastModified: string;
  boUserId?: string | null;
}

export class GetActiveResearcherProjectsPaginationResponse {
  readonly isGetActiveResearcherProjectsPaginationResponseGetActiveResearcherProjectsPaginationResponse: boolean = true;

  readonly projectId: LeoUUID;
  readonly projectName: string;
  readonly creator: string;
  readonly surveys: string;
  readonly createdOn: LeoTimestamp;
  readonly lastModified: LeoTimestamp;
  readonly boUserId: LeoUUID | null;


  constructor(
  projectId: LeoUUID, 
  projectName: string, 
  creator: string, 
  surveys: string, 
  createdOn: LeoTimestamp, 
  lastModified: LeoTimestamp, 
  boUserId: LeoUUID | null = null
  ) {
    this.projectId = projectId;
    GetActiveResearcherProjectsPaginationResponse.validateProjectName(projectName);
    this.projectName = projectName;
    GetActiveResearcherProjectsPaginationResponse.validateCreator(creator);
    this.creator = creator;
    GetActiveResearcherProjectsPaginationResponse.validateSurveys(surveys);
    this.surveys = surveys;
    this.createdOn = createdOn;
    this.lastModified = lastModified;
    this.boUserId = boUserId;
  }

  static fromDTO(dto: GetActiveResearcherProjectsPaginationResponseDTO): GetActiveResearcherProjectsPaginationResponse {
    const projectId = getLeoUuid(dto, "projectId", InvalidGetActiveResearcherProjectsPaginationResponseProjectIdError);
    const projectName = getString(dto, "projectName", InvalidGetActiveResearcherProjectsPaginationResponseProjectNameError);
    const creator = getString(dto, "creator", InvalidGetActiveResearcherProjectsPaginationResponseCreatorError);
    const surveys = getString(dto, "surveys", InvalidGetActiveResearcherProjectsPaginationResponseSurveysError);
    const createdOn = getLeoTimestamp(dto, "createdOn", InvalidGetActiveResearcherProjectsPaginationResponseCreatedOnError);
    const lastModified = getLeoTimestamp(dto, "lastModified", InvalidGetActiveResearcherProjectsPaginationResponseLastModifiedError);
    const boUserId = getOptionalLeoUuid(dto, "boUserId", InvalidGetActiveResearcherProjectsPaginationResponseBoUserIdError);
    return new GetActiveResearcherProjectsPaginationResponse(
      projectId,
      projectName,
      creator,
      surveys,
      createdOn,
      lastModified,
      boUserId
    );
  }

  toDTO(): GetActiveResearcherProjectsPaginationResponseDTO {
    const dto: GetActiveResearcherProjectsPaginationResponseDTO = {
        projectId: this.projectId.toDTO(),
        projectName: this.projectName,
        creator: this.creator,
        surveys: this.surveys,
        createdOn: this.createdOn.toDTO(),
        lastModified: this.lastModified.toDTO(),
    };
    if (this.boUserId !== undefined && this.boUserId !== null){
      dto.boUserId = this.boUserId.toDTO();
    }
    return dto;
  }
  private static validateProjectName = (projectName: string): void => {
    if(projectName.trim().length === 0) {
      throw new InvalidGetActiveResearcherProjectsPaginationResponseProjectNameNonEmptyError(
        `Attribute projectName cannot be an empty string.`
      );
    }
  }
  private static validateCreator = (creator: string): void => {
    if(creator.trim().length === 0) {
      throw new InvalidGetActiveResearcherProjectsPaginationResponseCreatorNonEmptyError(
        `Attribute creator cannot be an empty string.`
      );
    }
  }
  private static validateSurveys = (surveys: string): void => {
    if(surveys.trim().length === 0) {
      throw new InvalidGetActiveResearcherProjectsPaginationResponseSurveysNonEmptyError(
        `Attribute surveys cannot be an empty string.`
      );
    }
  }
  
}

GetActiveResearcherProjectsPaginationResponse.prototype.toString = function toString(): string {
  return `GetActiveResearcherProjectsPaginationResponse(projectId='${this.projectId}',projectName='${this.projectName}',creator='${this.creator}',surveys='${this.surveys}',createdOn='${this.createdOn}',lastModified='${this.lastModified}',boUserId='${this.boUserId}')`;
};

export class InvalidGetActiveResearcherProjectsPaginationResponseError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsPaginationResponseError";
  }
}
export class InvalidGetActiveResearcherProjectsPaginationResponseProjectIdError extends InvalidGetActiveResearcherProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsPaginationResponseProjectIdError";
  }
}

export class InvalidGetActiveResearcherProjectsPaginationResponseProjectNameError extends InvalidGetActiveResearcherProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsPaginationResponseProjectNameError";
  }
}

export class InvalidGetActiveResearcherProjectsPaginationResponseProjectNameNonEmptyError extends InvalidGetActiveResearcherProjectsPaginationResponseProjectNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsPaginationResponseProjectNameNonEmptyError";
  }
}

export class InvalidGetActiveResearcherProjectsPaginationResponseCreatorError extends InvalidGetActiveResearcherProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsPaginationResponseCreatorError";
  }
}

export class InvalidGetActiveResearcherProjectsPaginationResponseCreatorNonEmptyError extends InvalidGetActiveResearcherProjectsPaginationResponseCreatorError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsPaginationResponseCreatorNonEmptyError";
  }
}

export class InvalidGetActiveResearcherProjectsPaginationResponseSurveysError extends InvalidGetActiveResearcherProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsPaginationResponseSurveysError";
  }
}

export class InvalidGetActiveResearcherProjectsPaginationResponseSurveysNonEmptyError extends InvalidGetActiveResearcherProjectsPaginationResponseSurveysError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsPaginationResponseSurveysNonEmptyError";
  }
}

export class InvalidGetActiveResearcherProjectsPaginationResponseCreatedOnError extends InvalidGetActiveResearcherProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsPaginationResponseCreatedOnError";
  }
}

export class InvalidGetActiveResearcherProjectsPaginationResponseLastModifiedError extends InvalidGetActiveResearcherProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsPaginationResponseLastModifiedError";
  }
}

export class InvalidGetActiveResearcherProjectsPaginationResponseBoUserIdError extends InvalidGetActiveResearcherProjectsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetActiveResearcherProjectsPaginationResponseBoUserIdError";
  }
}
